/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateRoleRequest { 
    name: string;
    tenantId?: string | null;
    permissionIds: Array<string>;
}

